module.exports = __webpack_public_path__ + "img/Groupe 69.d779aa41.svg";